import React from 'react'
import PageLayout from '../../Components/Layout/PageLayout';
import { FormProvider,useForm } from 'react-hook-form';
import { ActionButtons ,SupportButtons} from '../../../global/components/Buttons/buttons';
import { useNavigate } from 'react-router';
import {
  FormInput,
  FormTemplate,
  RadioBox
} from "../../Components/Forms/InputTemplate";
import DashboardStyle from "../../../dashboard/Styles/Dashboard.module.css";
import { useState } from 'react';
import { AddConsent } from '../../../../utils/redux/HR/HRSlice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
const Palliative = () => {
  const [consent, setConsent] = useState(''); // State to track consent choice
  const[IsConsent, SetIsConsent] = useState(false);
  const location = useLocation()?.state;
  const handleConsentChange = (e) => {
    setConsent(e.target.value);
  };

  const defaultData={
    pin: location?.pin,
    email:location?.email,
    firstname:location?.firstname,
    othername:location?.othername,
    surname:location?.surname,
    isConsent:location?.isConsent,
    phoneNumber:location?.phoneNumber
  };

  console.log(location);

  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });

  const {
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { isValid },
  } = formMethods;

const navigate = useNavigate();
const dispatch = useDispatch();

const submit = (data)=>{
  const totalData = {
    ...data,
  };

  if(consent ==='yes'){
    SetIsConsent(true);
  }
  console.log(totalData);
  // var formData = new FormData();
  // console.log(formData);
  // dispatch(AddConsent(defaultData))?.then((res) => {
  //   //console.log( res );
  //   if (res?.payload?.successful === true) {
  //     navigate(`../`);
  //   }
  // });
}
  return (
    <PageLayout
    title={location ? "Palliative Consent Form": "palliative Consent form"}
  >
    <FormProvider {...formMethods}>
      <FormTemplate
        className={DashboardStyle.view_app_components}
        handleSubmit={handleSubmit(submit)}
      >
        <section className={DashboardStyle.form_section_md}>
            <div>
              <FormInput
              title={"RSA PIN"}
              placeholder={"RSA PIN"}
              camelCase={"pin"}
              />
              <FormInput
              title={"First Name"}
              placeholder={"First Name"}
              camelCase={"firstname"}
              />
              <FormInput
              title={"Surname"}
              placeholder={"Surname"}
              camelCase={"surname"}
              type={"text"}
              />
              <FormInput
              title={"Other Name"}
              placeholder={"Other Name"}
              camelCase={"othername"}
              type={"text"}
              isOptional={true}
              />
              <FormInput
              title={"Email"}
              placeholder={"Email Address"}
              camelCase={"email"}
              type={"email"}
              isOptional={true}
              />
              <FormInput
              title={"Phone Number"}
              placeholder={"Phone Number"}
              camelCase={"phoneNumber"}
              type={"text"}
              />
              <p>
                I hereby give consent to NLPC PFA to release my bank details to PENCOM and the Federal Government for the payment of Palliative
              </p>
              <RadioBox
                name="Yes, I give consent"
                camelCase="isConsent"
                group="consentGroup"
                value="yes"
                moreRegister={{
                  onChange: handleConsentChange,
                  checked: consent === 'yes'
                }}
              />
              {/* <RadioBox
                name="No, I do not give consent"
                camelCase="consentNo"
                group="consentGroup"
                value="no"
                moreRegister={{
                  onChange: handleConsentChange,
                  checked: consent === 'no'
                }}
              /> */}
              
          </div>
        </section>
        <div className={DashboardStyle.button_cage}>
          <SupportButtons
            width={"auto"}
            onClick={() => navigate(-1)}
            >
            Cancel
          </SupportButtons>
          <ActionButtons
              width={"auto"}
              disabled={!isValid}
              className={DashboardStyle?.button_cage_weight}
            >
              Submit
              {/* {isLoadingAction ? "Submitting..." : "Submit"} */}
          </ActionButtons>
        </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    )
}

export default Palliative;
